import { render, staticRenderFns } from "./FlowObjectFileGroup.vue?vue&type=template&id=6c4088b1&scoped=true"
import script from "./FlowObjectFileGroup.vue?vue&type=script&lang=js"
export * from "./FlowObjectFileGroup.vue?vue&type=script&lang=js"
import style0 from "./FlowObjectFileGroup.vue?vue&type=style&index=0&id=6c4088b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4088b1",
  null
  
)

export default component.exports